import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight, Loader2, ShieldCheck } from "lucide-react";
import { auth, formatApiError } from "@/lib/api";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  if (auth.getToken()) {
    return <Navigate to="/admin" replace />;
  }

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await auth.login(email, password);
      navigate("/admin", { replace: true });
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-[100svh] items-center justify-center bg-[var(--bg)] px-5 py-10">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: [0.2, 0.9, 0.2, 1] }}
        className="w-full max-w-sm"
      >
        <div className="mb-6 flex items-center gap-3">
          <ShieldCheck className="h-4 w-4 text-[var(--pink)]" strokeWidth={2.2} />
          <span className="font-mono text-[11px] uppercase tracking-super text-[var(--pink)]">
            Painel · admin
          </span>
        </div>

        <h1 className="font-serif text-4xl leading-[0.9] tracking-tight text-white md:text-5xl">
          Área <span className="italic text-[var(--pink)]">restrita.</span>
        </h1>
        <p className="mt-3 font-mono text-[13px] text-white/60">
          Entre com seu email e senha para acessar o painel de leads.
        </p>

        <form onSubmit={submit} className="mt-8 space-y-4" data-testid="admin-login-form">
          <div>
            <label
              htmlFor="admin-email"
              className="mb-2 block font-mono text-[10px] uppercase tracking-super text-white/50"
            >
              Email
            </label>
            <input
              id="admin-email"
              type="email"
              autoComplete="username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="input"
              placeholder="admin@julssy.com"
              data-testid="admin-input-email"
              required
            />
          </div>

          <div>
            <label
              htmlFor="admin-password"
              className="mb-2 block font-mono text-[10px] uppercase tracking-super text-white/50"
            >
              Senha
            </label>
            <input
              id="admin-password"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="input"
              placeholder="••••••••"
              data-testid="admin-input-password"
              required
            />
          </div>

          {error && (
            <div
              className="border border-red-400/40 bg-red-400/10 px-3 py-2 font-mono text-[11px] text-red-300"
              data-testid="admin-error"
            >
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            className="btn-magnetic w-full justify-center disabled:opacity-60"
            data-testid="admin-submit"
          >
            {loading ? (
              <>
                <Loader2 className="h-4 w-4 animate-spin" />
                Entrando…
              </>
            ) : (
              <>
                <span>Entrar</span>
                <ArrowUpRight className="arrow h-4 w-4" strokeWidth={2.4} />
              </>
            )}
          </button>
        </form>
      </motion.div>
    </div>
  );
}
